export const INTEGRATION_STATUS = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
} as const;

export const INTEGRATION_TYPE = {
  STRIPE: "stripe",
  ZOOM: "zoom",
  ZOOM_APP: "zoom_app",
  SPRUCE: "spruce",
} as const;

/** Maps integration type values to API path segments. */
export const INTEGRATION_API_PATH = {
  [INTEGRATION_TYPE.STRIPE]: "stripe",
  [INTEGRATION_TYPE.ZOOM]: "zoom",
  [INTEGRATION_TYPE.ZOOM_APP]: "zoom-app",
  [INTEGRATION_TYPE.SPRUCE]: "spruce",
} as const;
